import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../ts/ServerApi/types/actionParams';

export interface IRunExtractRefreshesOnDatasourcesParams extends IMultipleIdsParams {
  type: string; // ExtractTaskType
}

export class RunExtractRefreshesOnDatasourcesRequest extends Request<IRunExtractRefreshesOnDatasourcesParams, IResult> {
                          // type must be from ExtractTaskType
  constructor(ids: string[], type: string) {
    super('runExtractRefreshesOnDatasources', {
      ids: ids,
      type: type
    });
  }
}
